import React, { useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DashboardCard = ({ icon, color, count, label, isSelected, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const cardStyle = {
    backgroundColor: isSelected ? "#332885" : isHovered ? "#332885" : "#ffffff",
    color: isSelected || isHovered ? "#ffffff" : color,
  };

  return (
    <div
      className="col-md-3"
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ cursor: "pointer" }}
    >
      <div className="card card-css" style={cardStyle}>
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <FontAwesomeIcon
              icon={icon}
              style={{
                color: isSelected || isHovered ? "#ffffff" : color,
                fontSize: "2rem",
              }}
            />
            <div style={{ textAlign: "right" }} className="text-right">
              <h3
                style={{ color: isSelected || isHovered ? "#ffffff" : color }}
              >
                {count}
              </h3>
              <p style={{ color: isSelected || isHovered ? "#ffffff" : color }}>
                {label}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardCard.propTypes = {
  icon: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  count: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default DashboardCard;
